import SingleSearchForm from "./SingleSearchForm";
import { compose, setDisplayName, withHandlers, withProps } from "recompose";
import { objectToQueryString } from "../helpers/index";
import { faSearch } from "@fortawesome/fontawesome-free-solid";
import { connect } from "react-redux";
import { actions } from "../modules/customers";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/g;

const determineFilter = data => {
  let filter = "customer";
  let value = "";
  if (data && data.customer) {
    if (emailRegex.test(data.customer)) {
      filter = "email";
    } else if (phoneRegex.test(data.customer)) {
      filter = "phone_number";
    }
    value = data.customer;
  }
  return { [filter]: value };
};

const defaultCompletion = () => {};

const SearchCustomerForm = compose(
  setDisplayName("SearchCustomerForm"),
  connect(
    state => ({
      currentDealer: state.dealers.currentDealer,
      fetchingCustomers: state.customers.loadingFetchCustomers,
      failFetchCustomers: state.customers.failureFetchCustomers,
      currentPage: state.customers.currentPage,
      totalPages: state.customers.totalPages
    }),
    {
      fetchCustomers: actions.fetchCustomers,
      setCurrentPage: actions.setCurrentPage,
      setFilter: actions.setFilter
    }
  ),
  withHandlers(({ onSearchCustomers }) => {
    return {
      handleSubmit: ({
        fetchCustomers,
        currentDealer,
        setCurrentPage,
        setFilter
      }) => data => {
        setFilter(determineFilter(data));
        setCurrentPage(1);
        fetchCustomers({
          dealer_id: currentDealer.id,
          query_string: objectToQueryString(
            Object.assign({}, data, { page: 1, per_page: 10 })
          )
        }).then(onSearchCustomers || defaultCompletion);
      },
      onPageChange: ({
        fetchCustomers,
        currentDealer,
        setCurrentPage,
        setFilter
      }) => data => page => {
        setFilter(determineFilter(data));
        setCurrentPage(page);
        fetchCustomers({
          dealer_id: currentDealer.id,
          query_string: objectToQueryString(
            Object.assign({}, data, { page, per_page: 10 })
          )
        }).then(onSearchCustomers || defaultCompletion);
      }
    };
  }),
  withProps(
    ({ fetchingCustomers, failFetchCustomers, handleSubmit, totalPages }) => ({
      initialValues: { customer: "" },
      name: "customer",
      placeholder: "Customer name or email",
      icon: faSearch,
      action: "Search",
      submitting: fetchingCustomers,
      failSubmit: failFetchCustomers,
      onSubmit: handleSubmit,
      showPagination: totalPages > 1
    })
  )
)(SingleSearchForm);

export default SearchCustomerForm;
